/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const RailRightOpenIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Rail Right Open',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    height="${height}"
    viewBox="0 0 36 36"
    width="${width}"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14 14h9.006a.994.994 0 0 1 .994.994v6.012a.994.994 0 0 1-.994.994H14v8.912a.5.5 0 0 1-.848.351L0 18 13.152 4.736a.5.5 0 0 1 .848.352Z"
    />
    <rect height="28" rx=".707" ry=".707" width="4" x="28" y="4" />
  </svg>`;
};
